if (!customElements.get('cinepack-details')) {
  class CinepackDetails extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.mobileBreakpoint = 600;
      this.rafId = null;
      this.handleResize = this.handleResize.bind(this);
      this.scheduleAlign = this.scheduleAlign.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('load', this.scheduleAlign);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.scheduleAlign);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('load', this.scheduleAlign);
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.destroySwiper();
    }

    get swiperContainer() {
      return this.querySelector('.cinepack-details__swiper');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
        centeredSlides: false,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
      };
    }

    handleResize() {
      const isMobile = window.innerWidth < this.mobileBreakpoint;

      if (isMobile && !this.swiper) {
        this.initSwiper();
      } else if (!isMobile && this.swiper) {
        this.destroySwiper();
      }

      this.scheduleAlign();
    }

    initSwiper() {
      if (this.swiperContainer && typeof Swiper !== 'undefined') {
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    scheduleAlign() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => this.alignRows());
    }

    /* Equalise the title height (so every subtitle starts at the same position)
       and the subtitle height (so every description starts at the same position)
       across all cards. Card heights themselves stay row-by-row via the CSS grid. */
    alignRows() {
      this.equalize(this.querySelectorAll('.cinepack-detail-card__title'));
      this.equalize(this.querySelectorAll('.cinepack-detail-card__subtitle'));
      if (this.swiper) this.swiper.update();
    }

    equalize(elements) {
      if (!elements.length) return;

      // Clear any previous override before measuring natural heights.
      elements.forEach((el) => {
        el.style.minHeight = '';
      });

      if (elements.length < 2) return;

      let max = 0;
      elements.forEach((el) => {
        max = Math.max(max, el.offsetHeight);
      });

      elements.forEach((el) => {
        el.style.minHeight = `${max}px`;
      });
    }
  }

  customElements.define('cinepack-details', CinepackDetails);
}
